export const DATE_FORMAT_INTL_CONSTANTS = {
    dateFormatTemplate: 'dateFormatIntlTemplate',
    defaultFormat: 'YYYY-MM-DD',
    defaultLocale: 'en-US',
    localeCookie: 'localeCookie_jar_aka',
    localeCookieProd: 'localeCookie_jar'
};
